<template>
  <div>
    <Dialog 
          :header="'Thông tin sản phẩm sữa chữa bảo hành'"
          :visible.sync="displayDialog"
          :class="'popup-dialog-customer'"
          :modal="true"
          @hide="hide_popup"
        ><!--:contentStyle="{overflow: 'visible'}"-->
        <div class="p-fluid"><!--:style="{width: '76vw'}"-->
          <div class="p-col-12 form-popup-custom-lookup box-lookup-product" v-if="objectPopup.mode== 'add'">
            <div class="p-grid">
              <div class="p-col-6 box-left"  >
                <div class="p-field">
                  <div class="p-field">
                    <label class="title_group_lookup">TRA CỨU SẢN PHẨM</label>
                  </div>
                </div>
                <div class="p-field  box_group_item">
                  <div class="p-field">
                    <label class="class_bold">Serial number</label>
                  </div>
                  <div class="p-field">
                    <InputText placeholder="Nhập serial number" v-model="serial_number_lookup"  autocomplete="off" type="text" style="width: calc(100% - 152px)"   />
                    <Button @click="load_product_serial" style="width: 120px;height: 40px;text-align: center;margin-left: 32px;background: linear-gradient( 180deg, rgba(66, 139, 202, 1) 0%, rgba(66, 139, 202, 1) 0%, rgba(45, 108, 162, 1) 100%, rgba(45, 108, 162, 1) 100%);font-size: 14px; color: #FFFFFF;font-weight: 700; font-style: normal;border-color: rgba(40, 94, 142, 1);" class="p-button-success btn-custom" :label="'Tra cứu'"/>
                  </div>
                </div>
                <div class="p-field">
                  <div class="p-field">
                    <label style="font-weight: 400; font-style: italic; font-size: 12px;color: #333333;">* Tra cứu sản phẩm khác thì các dữ liệu đã nhập sẽ bị mất</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="p-col-12 form-popup-custom-lookup">
            <div class="p-grid">
              <div class="p-col-12 p-md-6 p-lg-6 box-left">
                <div class="p-field" v-if="objectPopup.mode != 'detail_receive'">
                  <div class="p-field">
                    <label class="title_group_lookup">THÔNG TIN DỊCH VỤ</label>
                  </div>
                </div>
                <div class="p-field box_group_item" v-if="objectPopup.mode != 'detail_receive'">
                  <div class="p-field">
                    <div class="p-fluid p-formgrid p-grid">
                      <div class="p-field p-col">
                        <label class="class_bold" >Loại dịch vụ<span class="error">*</span></label>
                        <Dropdown v-model="objectPopup.type_service" :options="list_type_service" optionLabel="label" optionValue="value" placeholder="Chọn loại dịch vụ"  />
                        <small v-if="validationErrors && validationErrors['type_service']" class="p-invalid">{{ validationErrors['type_service'] }}</small>
                      </div>
                      <div class="p-field p-col" >
                        <div v-if="(!$myConstants.isEmpty(objectPopup.type_service)) && objectPopup.type_service==$dataCommon.WARRANTY_REPAIR.TYPE_SERVICE.MAINTENANCE">
                        <label >Đợt bảo trì<span class="error">*</span></label>
                        <Dropdown v-model="objectPopup.maintenance_period"  :options="list_maintenance_sessions"  optionLabel="lable"  optionValue="id" />
                          <small v-if="validationErrors && validationErrors['maintenance_period']" class="p-invalid">{{ validationErrors['maintenance_period'] }}</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="p-field">
                  <div class="p-field">
                    <label class="title_group_lookup">TÌNH TRẠNG SẢN PHẨM</label>
                  </div>
                </div>
                <div class="p-field box_group_item">
                  <div class="p-field">
                    <label class="class_bold">Mô tả tình trạng của sản phẩm</label>
                  </div>
                  <div class="p-field">
                    <Textarea :disabled="objectPopup.mode == 'detail_receive'" maxlength="5000" id="description" rows="5" v-model="objectPopup.desc_status_product" :autoResize="true"/>
                  </div>
                </div>
                <div class="p-field box_group_item">
                  <div class="p-field">
                    <label class="class_bold">Hình ảnh tình trạng của sản phẩm</label>
                  </div>
                  <div class="p-field" v-if="objectPopup.mode != 'detail_receive'">
                    <Button :label="'Chọn'" icon="pi pi-plus" @click="openFile" />
                    <input id="files" ref="files" type="file" multiple style="display:none" @change="chooseFile"/>
                  </div>
                </div>
                <div class="p-field box_group_item" v-if="files && files.length">
                  <div class="p-field box-list-img">
                    <CoolLightBox
                        :items="files"
                        :index="indexUpload"
                        :fullScreen="true"
                        @close="indexUpload = null">
                    </CoolLightBox>
                    <div class="images-wrapper p-grid">
                      <div class="p-col-3 item-img"   :key="indexImg" v-for="(itemImg, indexImg) in files">
                        <div class="item" >
                          <div v-if="objectPopup.mode != 'detail_receive'" class="remove-icon" @click="removeImg(indexImg)"> <span class="pi pi-times" ></span></div>
                          <div class="image"  @click="indexUpload = indexImg">
                            <img style="width: 100px;height: 150px" :src="itemImg.src">
                          </div>
                          <!--<img :src="itemImg.src" style="width: 50px;height: 50px">-->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="p-col-12 p-md-6 p-lg-6 box-right">
                <InfoSerial :objectPopup="objectPopup" ></InfoSerial>
                </div>
              </div>
            </div>
          </div>
        <template #footer>
          <div v-if="objectPopup">
            <div v-if="objectPopup.mode =='add'">
              <!--<Button  class="p-button-success" :label="'Thêm vào danh sách'" @click="saveData" />-->
              <button @click="saveData('add')" class="add_btn_data" style="" >
                <img class="style_icon_add" style="" src="../../../../public/assets/images/playlist_add_u605.png"/>
                <span class="style_text" style="">Thêm vào danh sách</span>
              </button>
            </div>
             <Button v-if="objectPopup.mode =='edit'" class="p-button-success" :label="'Lưu'" @click="saveData('edit')" />
          </div>

        </template>
      </Dialog>
    <Dialog
        class="dialog-comfirm-common"
        :visible.sync="showConfirmDialog"

        :modal="true"
        :closable="true"
    ><!-- :contentStyle="{overflow: 'visible'}"-->
      <div class="box_body_popup" >
        <div >
          <!--<div class="box_title_suceess"><img class="img_noti" :src="check_success_img" /><span class="title_noti" style="">Thành công</span></div>-->
          <p class="p_title_1" style="text-align: center">Bạn có đồng ý tiếp tục thêm sản phẩm vào danh sách thực hiện?</p>
          <p  style="text-align: center"><span style="font-weight: 700">Lưu ý: Serial number <span style="color: #FF0000">{{(objectPopup.object_info_product) ? objectPopup.object_info_product.serial_number:''}}</span> đang được thực hiện các dịch vụ bên dưới</span></p>
          <BaseCommonList
              v-if="list_product_exist.dataModel"
              :classDatatable="'list_product_exist'"
              :countCheckBox="true"
              :labelHeaderAction="'Xóa'"
              :key="list_product_exist.componentKey"
              :listData="list_product_exist.listData"
              :model="list_product_exist.dataModel"
              :filterDefault="list_product_exist.filters"
              :columnsDisplays="list_product_exist.columnsDisplays"
              :pagination="false"
          ></BaseCommonList><!--:columnsDisplays="list_product_serial.columnsDisplays"  ẩn cột-->
        </div>
        <div class="p-grid box-btn-button">
          <div class="p-col-5">
            <div class="box" style="text-align: right">
              <Button
                  iconPos="right"
                  class="btn-custom btn-button-popup btn-accept-serail"
                  :label="'Đồng ý'"
                  type="button"
                  @click="acceptAddProduct"
              > </Button>
            </div>
          </div>
          <div class="p-col-5 p-offset-2">
            <div class="box" style="text-align: left">
              <Button
                  iconPos="right"
                  class="btn-custom btn-button-popup p-button-danger"
                  :label="'Hủy'"
                  type="button"
                  @click="closePopupConfirm"
              > </Button>
            </div>
          </div>
        </div>
      </div>
      <template #header>
        <div>
          <span class="title-confirm" >Xác nhận</span>
          <!--<span class="description-confirm">asdasdas</span>-->
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
import DataServices from '@/core/DataServices'
import InfoSerial from './info_serial'
import BaseCommonList from '../common'
export default {
  props: {
    show: Boolean,
    mode: String,
    modelName: String,
    model: Object,
    screen: String,
    objectData: Object,
    listDataCurrent: {
      type: Array,
      default: null
    },
  },
  components: {
    InfoSerial,
    BaseCommonList
  },
  data() {
    return {
        files: [],
        indexUpload: null,
        name: '',
        status: true,
        parent_id: 0,
        is_management: true,
        displayDialog: this.show,
        validationErrors: {},
        name_exists: false,
        optionsParent: [],
        submitForm: false,
        levelParentIndex: 0,
        description: '',
        list_maintenance_sessions:[],
        list_type_service:[],
        serial_number_lookup:'',
        objectPopup:{},
        object_product_lookup: {
          maintenance_period: null,
          type_service: null,
          desc_status_product: '',
          list_img_status_product: [],
          objectProductSerial: [],
        },
      showConfirmDialog:false,
      list_product_exist:{
        columnsDisplays: [],
        componentKey: 0,
        filters: {},
        listData: [],
        dataModel: null,
        rowFooterProductSerial: null,
      },
    }
  },
  async created() {
    this.formMode = this.mode;
    //var unit_active = null;
    /*if (this.formMode === 'edit' && this.model !== undefined && this.model !== null && Object.entries(this.model).length) {
     this.objectData = this.$myConstants.convertJsonObject(this.model);
     // unit_active = this.objectData.unit;
    }*/
    console.log("payloadpayloadpayloadpayload:",this.objectData)
    this.objectPopup = this.objectData;
    this.serial_number_lookup = (this.objectPopup.object_info_product) ? this.objectPopup.object_info_product.serial_number:'';
    this.files = this.objectPopup.list_img_status_product;
    //this.files = this.objectPopup.list_img_status_product;
    //console.log("this.objectPopup.list_img_status_product:",this.objectPopup.list_img_status_product)
    var list_maintence = await this.load_maintence(this.objectPopup.id);
    var is_exist_maintence = (list_maintence.length > 0) ? true:false;
    this.load_type_service(is_exist_maintence);

    this.list_product_exist.dataModel = DataServices.getModel('product_exist_warranty_repair');
    this.list_product_exist.listData = [];
    this.list_product_exist.componentKey++;

  },
  methods: {
    hide_popup(){
      this.$emit('close_popup_product');
    },
    removeImg(index) {
      this.files.splice(index, 1);
      if (this.files.length == 0) this.files = [];
    },
    openFile() {
      this.$refs.files.click();
    },
    chooseFile($event) {
      $event.preventDefault();
      $event.stopPropagation();
      var checkFile = false;
      var arrFiles = [];
      var fileSelects = $event.target.files || $event.dataTransfer.files;
      if (!fileSelects.length)
        return;
      for (let index = 0; index < fileSelects.length; index++) {
        const file = fileSelects[index];
        if (this.$myConstants.isImage(file.type)) {
          file.source = file;
          file.src = window.URL.createObjectURL(file);
          file.objectURL = window.URL.createObjectURL(file);
          arrFiles.push(file);
        } else {
          checkFile = true;
          break;
        }
      }
      if (checkFile) {
        this.$toast.add({ severity: 'error', summary: 'Thông báo', detail: 'Sai định dạng file', life: 3000 })
      } else {
        this.files = this.files.concat.apply(this.files, arrFiles);
      }
    },
    async load_product_serial() {
      var vm = this;
      this.$store.commit('setDataLoading', {content: 'Đang tải dữ liệu', icon: true});
      this.$store.commit('setLoading', true);
      setTimeout(function(){ vm.$store.commit('setLoading', false); }, 1000);
      var params = {
        serial_number_lookup: this.serial_number_lookup,
      }
      this.$emit('load_product_serial', params);
    },
    async getCodeNext() {
      var data =await DataServices.getObjectData('service_supplies',{},{id: 'desc'});
      if (!this.$myConstants.isEmpty(data)){
        var codeLast = data.code;
        var codeRightLast = codeLast.substring((codeLast.length - 6));//Cắt lấy 6 ký tự cuối cùng
        var codeRightTmp =(parseInt(codeRightLast) + 1).toString();
        return 'VT'+codeRightTmp.padStart(6, '0');
      }
      return 'VT000001';
    },
    async load_type_service(is_exist_maintence) {
      var list = await this.$coreService.get_warranty_repair_type_service_all();
        if (list !== undefined && list !== null && Object.keys(list).length) {
            for (let index = 0; index < list.length; index++) {
              const item = list[index];
              if (item.code == this.$dataCommon.WARRANTY_REPAIR.TYPE_SERVICE.MAINTENANCE){
                //Kiểm tra xem có tồn tại đợt bảo trì ko
                if (is_exist_maintence == true){
                  this.list_type_service.push({label: item.name, value: item.code, item: item});
                }
              }
              else if (item.code == this.$dataCommon.WARRANTY_REPAIR.TYPE_SERVICE.REPAIR_APPRAISAL){
                //Ẩn sửa chữa sp thẩm định
                if (item.code);
              }
              else {
                this.list_type_service.push({label: item.name, value: item.code, item: item});
              }

            }
        }
    },
    async load_maintence(serial_number_id) {
      var list = await this.$coreService.get_maintence_by_serial_number_id(serial_number_id,[this.$dataCommon.MAINTENANCE.PROCESS_STATUS.PLAN,this.$dataCommon.MAINTENANCE.PROCESS_STATUS.MAINTENANCE_NEEDED]);
      if (list !== undefined && list !== null && Object.keys(list).length) {
        for (let index = 0; index < list.length; index++) {
          list[index].lable = "Đợt "+list[index].parts_number;
        }
        this.list_maintenance_sessions = list;
      }
      return list;
    },
    async saveData(action) {
      //var vm = this;
      this.submitForm = true;
      await this.validationData();
      if (Object.entries(this.validationErrors).length === 0) {
        //Lấy danh sách serial đã tồn tại dịch vụ
        //this.objectPopup.id
        if (action == 'add') {
          var variables_product_serial_number = {
            where_key: {
              serial_number_id: {_eq: this.objectPopup.id},
              obj_warranty_repair: {status: {_eq: 1}},
              status: {_eq: 1}
            },
            orderBy: [{obj_warranty_repair: {process_status: 'asc'}}, {obj_warranty_repair: {id: 'desc'}}]
          }
          //Lấy ds sản phẩm
          var resProduct = await DataServices.getList('warranty_repair_product_serial_number', {"variables": JSON.stringify(variables_product_serial_number)});
          var listProduct = resProduct[Object.keys(resProduct)];
          console.log("listProductlistProduct:", listProduct)
          if (listProduct.length < 1) {
            this.saveAddProduct();
          } else {
            var listDataProduct = [];
            for (var i = 0; i < listProduct.length; i++) {
              var dataItemProduct = {
                code: (!this.$myConstants.isEmpty(listProduct[i].obj_warranty_repair)) ? listProduct[i].obj_warranty_repair.code : '',
                receive_day_reception: (!this.$myConstants.isEmpty(listProduct[i].obj_warranty_repair)) ? listProduct[i].obj_warranty_repair.receive_day_reception : '',
                process_status: (!this.$myConstants.isEmpty(listProduct[i].obj_warranty_repair)) ? listProduct[i].obj_warranty_repair.process_status : '',
                type_service: (!this.$myConstants.isEmpty(listProduct[i].type_service)) ? listProduct[i].type_service : '',
              };
              listDataProduct.push(dataItemProduct);
            }
            this.list_product_exist.listData = listDataProduct;
            this.list_product_exist.componentKey++;
            this.showConfirmDialog = true;
          }
        }else {
          this.saveAddProduct();
        }
      } else this.submitForm = false;
    },
    acceptAddProduct(){
      this.showConfirmDialog = false;
      this.saveAddProduct();
    },
    async saveAddProduct() {
      var vm = this;
      this.$store.commit('setDataLoading', {content: 'Đang lưu dữ liệu', icon: true});
      this.$store.commit('setLoading', true);
      this.serial_number_lookup = '';
      this.objectPopup.list_img_status_product = this.files;
      console.log("this.objectPopupthis.objectPopup:",this.objectPopup)
      this.$emit('add_product_serial_popup', this.objectPopup);
      if (this.objectPopup.mode == 'add'){
        //clear data
        this.objectPopup = {
          id:null,
          mode:'add',
          type_service:null,
          maintenance_period:null,
          desc_status_product:'',
          list_img_status_product:[],
          object_info_product:null
        }
        this.files = [];
      }
      setTimeout(async () => {
        vm.$store.commit('setLoading', false);
      }, 1000);
    },
    closePopupConfirm(){
      this.showConfirmDialog = false;
    },
    async validationData() {
      //var vm =this;
      this.validationErrors = {};
      if (this.$myConstants.isEmpty(this.objectPopup.id)){
        this.validationErrors['erro'] = 'Loi';//ghi để ko submit
        this.$toast.add({
          severity: 'error',
          summary: 'Thông báo',
          detail: 'Không tồn tại serial number.',
          life: 3000
        });
      }else {
      if (this.$myConstants.isEmpty(this.objectPopup.type_service)) {
        this.validationErrors['type_service'] = 'Chọn loại dịch vụ';
      }else {
        if (this.objectPopup.type_service == this.$dataCommon.WARRANTY_REPAIR.TYPE_SERVICE.MAINTENANCE){
          if (this.$myConstants.isEmpty(this.objectPopup.maintenance_period)){
            this.validationErrors['maintenance_period'] = 'Chọn đợt bảo trì';
          }
        }
      }
      var listDataCurrent = this.listDataCurrent;
      if (this.objectPopup.mode == 'add'){
        if (!this.$myConstants.isEmpty(listDataCurrent)){
          for (var i=0;i<listDataCurrent.length;i++){
            if (parseFloat(listDataCurrent[i].id) == parseFloat(this.objectPopup.id)){
              this.validationErrors['serial_number_id'] = 'serial đã thêm vào ds';//ghi để ko submit
              this.$toast.add({
                severity: 'error',
                summary: 'Thông báo',
                detail: 'Serial number đã tồn tại trong danh sách sản phẩm.',
                life: 3000
              });
              break;
            }
          }
        }
      }
      }
      if (!(Object.entries(this.validationErrors).length === 0)) {
        //Nếu tồn tại lỗi thì force để load validator mượt
        this.$forceUpdate();
      }
    },
    async getLevelIndex(whereKey) {
        var variables = {
            where_key: whereKey,
            orderBy: {
                'level_parent_index': 'desc'
            },
            limit: 1
        }
        var data = await DataServices.getList(this.modelName, {"fields": "id parent_id level_parent_index", "variables": JSON.stringify(variables)});
        if (data[Object.keys(data)].length) {
            data = data[Object.keys(data)][0];
            return data;
        }
        return null;
    },
  }
}
</script>

<style lang="scss" scoped>
  .form-popup-custom-lookup {
    .box-left {
      padding: 0px 15px 0px 0px
    }
    .box-right {
      padding: 0px 0px 0px 15px;
      @media (max-width: 767px) {
        padding: 0px;
      }
    }
    .box_group_item {
      margin-bottom: 16px;
    }
  }
  .box-lookup-product{
    border-bottom: 1px solid rgb(204, 204, 204);margin-bottom: 25px;
  }
.title_group_lookup{
  font-weight: 700; font-style: normal; font-size: 16px;
}
  .form-info{
    .message_err{
      text-align: right!important;font-weight: 400; font-style: italic; color: #FF0000; font-size: 14px;margin-bottom: 0px
    }
    .p-field{ padding: 10px;
      &:nth-child(n) {background: #E4E4E4;}
      &:nth-child(2n) {background: #fff;}
      label{ width: 200px; margin: 0;}
      .box-status{
        position: relative;
        background-color: rgba(153, 0, 204, 1);
        border-radius: 5px;
        text-align: center;
        //midle vertical
        display: inline-block;
        vertical-align: middle;
        padding-left: 9px;
        padding-right: 10px;
        padding-top: 2px;
        padding-bottom: 2px;
        .style-text-status{
          font-family: 'Arial Bold', 'Arial';
          font-weight: 700;
          font-style: normal;
          font-size: 14px;
          color: #FFFFFF;
        }
      }
      .box-value{
        width: calc(100% - 220px);//căn chỉnh để xuống thẳng hàng
        display: inline-block;
      }
    }
    .box-button{
      margin-top: 10px;
      .btn-done{
        width: 120px;
        float: left;
        margin-right: 32px;
        background: linear-gradient(180deg, rgba(66, 139, 202, 1) 0%, rgba(66, 139, 202, 1) 0%, rgba(45, 108, 162, 1) 100%, rgba(45, 108, 162, 1) 100%) !important;
        border: 1px solid #428bca;
        font-family: 'Arial Bold', 'Arial';
        font-weight: 700;
        font-style: normal;
        font-size: 14px;
        color: #FFFFFF;
        line-height: 24px;
      }
      .btn-false-report{
        width: 120px;
        background: linear-gradient(180deg, rgb(240, 173, 78) 0%, rgba(240, 173, 78, 1) 0%, rgba(235, 147, 22, 1) 100%, rgba(235, 147, 22, 1) 100%);
        border: 1px solid #F0AD4E;
        font-family: 'Arial Bold', 'Arial';
        font-weight: 700;
        font-style: normal;
        font-size: 14px;
        color: #FFFFFF;
        line-height: 24px;
      }
    }
  }
  .box-list-img{ margin: 0;
    .images-wrapper {
      .item-img {margin-bottom: 10px;
        .item{position: relative; text-align: center; width: 100%; margin: 0 auto;
          .remove-icon{cursor: pointer; position: absolute; right: -7px; top: -8px; color: #fff; background: #f00; width: 15px; height: 15px; overflow: hidden; border-radius: 50%;
            span{color: #fff; font-size: 8px; position: relative;top: -7.5px; left: 0px; font-weight: bold;}
          }
          .img {padding-top: 6px;
            img{max-width: 100%; height: auto;}
          }
        }
      }
    }
  }
  .images-wrapper { display: flex;
    .image {height: 150px; width: 100%; display: block; margin-right: 20px; cursor: pointer; background-size: cover;
      &:last-child{margin: 0;}
    }
  }
  .add_btn_data {
    position: relative;
    width: 194px !important;
    height: 40px;
    background: inherit;
    background-color: rgba(0, 204, 0, 1);
    border: none;
    border-radius: 5px;
    margin-right: 10px;
    margin-left: 10px;
    margin-top: 20px;

    .style_icon_add {
      position: absolute;
      margin-top: auto;
      margin-bottom: auto;
      top: 0;
      left: 0;
      bottom: 0;
      margin-left: 8px;
    }

    .style_text {
      position: absolute;
      margin-top: auto;
      margin-bottom: auto;
      top: 0;
      bottom: 0;
      left: 43px;
      height: fit-content;
      font-family: 'Arial Bold', 'Arial';
      font-weight: 700;
      font-style: normal;
      font-size: 14px;
      color: #FFFFFF;
    }
  }

</style>
<style lang="scss">

.dialog-comfirm-common{
  width: 630px;
  .p-dialog-header{
    padding-bottom: 4px; padding-top: 4px;
  }
  .box_body_popup{
    width: 100%;
    .p_title_1{
      text-align: center;margin-bottom: 0px;
    }
    .p_title_2{
      text-align: center;
    }
    .box_btn{
      text-align: center;
      margin-top: 8px;
    }
    .box_title_suceess{
      margin-bottom: 10px;
      .img_noti{
        width: 20px;
        height: 20px;
      }
      .title_noti{
        font-family: 'Arial Bold', 'Arial'; font-weight: 700; font-style: normal; font-size: 18px; color: #009900;margin-left: 8px
      }
    }
    .box_title_err{
      margin-bottom: 10px;
      .img_noti{
        width: 20px;
        height: 20px;
      }
      .title_noti{
        font-family: 'Arial Bold', 'Arial'; font-weight: 700; font-style: normal; font-size: 18px; color: #FF0000;margin-left: 8px
      }
    }
    .box-btn-button{
      margin-top: 16px;
      .btn-button-popup{
        width: 89px;
      }
      .btn-accept-serail{
        background: linear-gradient(
                180deg, rgba(66, 139, 202, 1) 0%, rgba(66, 139, 202, 1) 0%, rgba(45, 108, 162, 1) 100%, rgba(45, 108, 162, 1) 100%);
        border-color: rgba(40, 94, 142, 1);
      }
    }

  }
}
.list_product_exist .p-filter-column {
  display: none;
}
</style>
<style>
.popup-dialog-customer {
  width: 1090px !important;
}
@media (max-width: 991px) {
  .popup-dialog-customer {
   /* //width: 80vw !important;*/
    width: 828px !important;
  }
}
@media (max-width: 640px) {
  .popup-dialog-customer {
    width: 110vw !important;
  }
}

@media (max-width: 767px) {
  .popup-dialog-customer .box-right .info_product_serial {
  padding: 0px;
}
}
.timeline {
  font-weight: bold;
  font-style: italic;
  padding-left: 5px;
}
.class_bold{
  font-weight: bold;
}
</style>
